import { render, staticRenderFns } from "./SyGlass.vue?vue&type=template&id=6363fc3e&"
import script from "./SyGlass.vue?vue&type=script&lang=js&"
export * from "./SyGlass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports